export default __webpack_public_path__ + "static/media/ethereum.f7377480.svg";